import {
  FetchNavFlowcodeDirectoriesType,
  GetNavFlowcodeDirectoriesResponseType
} from './side.types'
import { GET_NAV_FLOWCODE_DIRECTORIES_QUERY } from '@app/code/src/gql/queries/flowcode'
import { gqlFetcher } from '@dtx-company/inter-app/src/services/gqlFetcher'
import useSWR from 'swr'

export const useGetNavDirectories = (token?: string): FetchNavFlowcodeDirectoriesType => {
  const data = useSWR(
    () => (token ? [GET_NAV_FLOWCODE_DIRECTORIES_QUERY, token] : null),
    ([query, token]) =>
      gqlFetcher<GetNavFlowcodeDirectoriesResponseType>(
        query,
        { orderBy: 'name' },
        undefined,
        token
      ),
    {
      revalidateOnFocus: false
    }
  )
  return {
    ...data,
    isLoading: !data.error && !data.data
  }
}
